module.exports = __webpack_public_path__ + "static/media/online_safety_checklist-CH_combine.776f0a63.pdf";